import GS from '../grafsync/grafsync';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles } from './style/gstheme';

const styles = Object.assign({
    iriChip: {
        color: 'white',
        marginRight: 10,
        marginBottom: 10,
        maxWidth: '100%'
    },
    iriChipLabel: {
        maxWidth: 'calc(90% - 20px)',
        overflow: 'hidden',
        display: 'inline-block',
        textOverflow: 'ellipsis'
    }
}, globalStyles);

class IriLink extends React.Component {

    handleDeleteLink = () => {
        // We do this directly to ensure direction of link delete is correct 
        GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.iri, null, null);
    };

    handleClick() {
        if (this.props.link) this.props.history.push(this.props.link);
    }

    render() {

        const { iri, classes, icon, source, isReadOnly, dataTest, label } = this.props;

        return (
            <Tooltip title={iri}>
                <Chip
                    data-test={dataTest}
                    color="primary"
                    avatar={icon ? <Avatar style={{ backgroundColor: '#01579B' }}>{icon}</Avatar> : null}
                    onClick={() => this.handleClick()}
                    onDelete={!isReadOnly && source ? this.handleDeleteLink : null}
                    label={label || iri}
                    className={classes.iriChip}
                    classes={{
                        label: classes.iriChipLabel
                    }}
                />
            </Tooltip>
        );
    }
}

IriLink.defaultProps = {
    isReadOnly: false
};

IriLink.propTypes = {
    dataTest: PropTypes.string,
    isReadOnly: PropTypes.bool,
    link: PropTypes.string,
    label: PropTypes.string,
    iri: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    icon: PropTypes.object,
    source: PropTypes.string,
    property: PropTypes.string,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(IriLink));